import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, AfterViewInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OneBreadcrumb } from '@one/angular-kit/navigation';
import { Chart } from 'chart.js';
import 'chartjs-plugin-doughnutlabel';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StatusDialogComponent } from '../status-dialog/status-dialog.component';
import { statusIcon } from '../../constants';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import qnsbnurlAPI from '../../services/qn-sbn-API-url';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { AppUtils } from 'projects/dialog/src/app/shared/utilities/app-utils';
import { FilterOverlayDialogComponent } from '../filter-overlay-dialog/filter-overlay-dialog.component';
import { FilterOverlayDialogService } from '../filter-overlay-dialog/filter-overlay-dialog.service';
import { accountTableColumns, accountTableInit } from '../../constants';
import { AddNoteComponent } from './add-note/add-note.component';
import { DueDateReminderComponent } from '../../create-notification/due-date-reminder/due-date-reminder.component';

@Component({
  selector: 'dl-notification-details',
  templateUrl: './notification-details.component.html',
  styleUrls: ['./notification-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class NotificationDetailsComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort, { static: true }) public sort: MatSort;
  @ViewChild('exporter', { static: true }) public exporter: ElementRef;

  @ViewChild('donutCustomer1') public donutCustomer1!: ElementRef;
  @ViewChild('donutCustomer2') public donutCustomer2!: ElementRef;
  
  public labels1 = ['Delivered ($count)', 'Delivery failures ($count)'];
  public labels2 = ['Submitted ($count)', 'Pending ($count)'];

  public colors1 = ['#00875a', '#c03']; 
  public colors2 = ['#0066cc', '#606060']; 

  public fontColor = '#333';

  public chartData1 = [0, 0];
  public chartData2 = [0, 0];

  public customerChartData1 = [0, 0];
  public customerChartData2 = [0, 0];

  public breadcrumbs: OneBreadcrumb[];

  public donutCustomerChart1: Chart;
  public donutCustomerChart2: Chart;

  public contactDataObj: any = [];
  public notificationDataObj: any;
  public notificationStatusIcon: {};
  public selection = new SelectionModel(true, []);
  public selectedRow: any;
  public dataSource = new MatTableDataSource<any>();
  public displayedColumns = ['select', 'allColumns'];
  public tableData: any[] = [];
  public selectedColumns: any;
  public StatusData: any;
  public notificationId: string;
  public featureRelease1 = qnsbnurlAPI.isRelease1;
  public notificationData: any;
  public filterOverlayData: any;
  public userPermission: any;

  public uniqueDDCount: number = 0;
  public uniqueDFCount: number = 0;

  public uniqueFSCount: number = 0;
  public uniqueFPCount: number = 0;


  public notificationLabel: any = '';
  public isSetCom: boolean = false;
  public accountDataSource = new MatTableDataSource<any>();
  public accountTableData: any[] = [];
  public accountSelectedColumns: any;
  public accountDataObj: any;
  public accountSelection = new SelectionModel(true, []);
  public AccountSelectedRow: any;
  @ViewChild('accountExporter', { static: true }) accountExporter: ElementRef;
  public feedbackEnabled: boolean = true;
  public calculateStatusCountsForDelivery;
  public calculateStatusCountsForFeedback;
  private isFetchingReminderDetails = false;

  public constructor(
    public filterOverlay: FilterOverlayDialogService, 
    public appUtil: AppUtils, 
    private route: ActivatedRoute, 
    private _cdr: ChangeDetectorRef, 
    private readonly oneSnackBar: OneSnackBarService, 
    private qnsbnservice: QnSbnService, 
    private changeDetectorRef: ChangeDetectorRef,
    private readonly dialog?: MatDialog,
  ){

    this.notificationDataObj = history.state;
    
    if (this.notificationDataObj) {
      this.notificationData = this.notificationDataObj.notificationData;
      this.notificationId = this.notificationData.NotificationId;
      this.feedbackEnabled = this.notificationData.FeedbackEnabled;
      this.contactDataObj = this.notificationDataObj.contactData;
      this.accountDataObj = this.notificationDataObj.accountDataObj;
    }
  }

  public ngOnInit(): void {
    this.notificationLabel = this.notificationData.LocalId;
    this.userPermission = this.qnsbnservice.getUserData();
    this.notificationStatusIcon = statusIcon[this.notificationData.Status];
    this.breadcrumbs = [
      {
        label: 'Notifications',
        url: '/notification'
      },
      {
        label: this.notificationData.LocalId
      }
    ];
    this.accountDataSource.sort = this.sort;
    this.accountTableData = accountTableColumns;
    this.accountDataSource.data = this.accountTableData;
    const accountSessionColumnsData = JSON.parse(sessionStorage.getItem('AccountSelectedColumns'));
    this.accountSelectedColumns = accountSessionColumnsData && accountSessionColumnsData.length > 0 ? accountSessionColumnsData : accountTableInit;

    this.calculateStatusCountsForDelivery=function(contacts) {

      let statusCounts1: {[key: string]: number} = {
        "Delivered": 0,
        "Delivery failures": 0
      };

      let customerStatus: {[key: string]: string} = {};

      contacts.forEach(contact => {
        const customerId = contact.AccountId;
        const contactStatus1 = contact.AccountDateDelivered;
        const contactStatus2 = contact.AccountStatus;

        if (!customerStatus[customerId]) {
          if (contactStatus2 === "Delivery Failed" && customerStatus[customerId] !== "Feedback Received")
          {
            customerStatus[customerId] = "Delivery failures";
          }
          else if(contactStatus1 !=="" && contactStatus2 !== "Delivery Failed" || contactStatus2 == "Delivered")
          {
            customerStatus[customerId] = "Delivered";
          }
        } 
        else {
          if (contactStatus2 === "Delivery Failed" && customerStatus[customerId] !== "Feedback Received") {
            customerStatus[customerId] = "Delivery failures";
          }
          else if(contactStatus1 !=="" && contactStatus2 !== "Delivery Failed" || contactStatus2 == "Delivered"){
            customerStatus[customerId] = "Delivered";
          }
        }
      });
      Object.values(customerStatus).forEach(status => {
        statusCounts1[status]++;
      });
      return statusCounts1;
    }

    this.calculateStatusCountsForFeedback=function(contacts) {

      let statusCounts2: {[key: string]: number} = {
        "Submitted": 0,
        "Pending": 0
      };
  
      let customerStatus: {[key: string]: string} = {};

      contacts.forEach(contact => {
        const customerId = contact.AccountId;
        const contactStatus = contact.AccountFeedbackReceived;

        if (!customerStatus[customerId]) {
          if (contactStatus == "") {
            customerStatus[customerId] = "Pending";
          }else{
            customerStatus[customerId] = "Submitted";
          }
        } else {
          if (contactStatus == "") {
            customerStatus[customerId] = "Pending";
          }else{
            customerStatus[customerId] = "Submitted";
          }
        }
      });
      Object.values(customerStatus).forEach(status => {
        statusCounts2[status]++;
      });
      return statusCounts2;
    }
  }

  public openStatusDialog() {
    sessionStorage.setItem('reloadOverview', 'true');
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = this.notificationDataObj;
    const dialogRef = this.dialog.open(StatusDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result.data) {
        this.StatusData = {
          NotificationId: this.notificationId,
          Status: 'Completed'
        };

        this.qnsbnservice.setNotificationStatus(this.StatusData).subscribe(
          (response: HttpResponse<any>) => {
            this.notificationData.Status = 'Completed';
            this.isSetCom = true;
            this.notificationStatusIcon = statusIcon[this.notificationData.Status];
            this._cdr.detectChanges();
            this.oneSnackBar.open('Set Notification Status Complete', OneSnackBarType.SUCCESS, '', { duration: 5000 });
          },
          (error: HttpErrorResponse) => {
            this.isSetCom = false;
            this.qnsbnservice.httpErrorHandler(error, 'Set Notification Status Failed.');
          }
        );
      }
    });
  }

  public areAllAccountsFeedbackOverdue(): boolean {
    if (!this.accountDataObj || !Array.isArray(this.accountDataObj) || this.accountDataObj.length === 0) {
      return false;
    }
    return this.accountDataObj.every(account => 
      account.AccountStatus?.toLowerCase() === 'feedback overdue'
    );
  }

  public ngAfterViewInit(): void {
    this.accountDataSource.data.forEach(row => {
      const hasSelect = this.accountSelectedColumns.some((item: any) => item.key === row.key);
      !row.disabled && hasSelect ? this.accountSelection.select(row) : '';
    });

    const statusCounts1 = this.calculateStatusCountsForDelivery(this.accountDataObj);
    const statusCounts2 = this.calculateStatusCountsForFeedback(this.accountDataObj);

    this.uniqueDDCount = statusCounts1["Delivered"];
    this.uniqueDFCount = statusCounts1["Delivery failures"];

    this.uniqueFSCount = statusCounts2["Submitted"];
    this.uniqueFPCount = statusCounts2["Pending"];    
    
    this.customerChartData1 = (this.uniqueDDCount!=0 || this.uniqueDFCount!=0) 
    ? [this.uniqueDDCount, this.uniqueDFCount]
    : [0,0,this.accountDataObj.length];

    this.customerChartData2 = [this.uniqueFSCount, this.uniqueFPCount];

    this.donutCustomerChart1 = new Chart(this.donutCustomer1.nativeElement, {
      type: 'doughnut',
      data: {
        labels: this.labels1,
        datasets: [
          {
            label: 'Donut Dataset',
            borderWidth: 0,
            backgroundColor: this.colors1,
            data: this.customerChartData1,
            borderColor: '#E557B3'
          }
        ]
      },
      options: {
        cutoutPercentage: 70,
        rotation: 120,
        maintainAspectRatio: false,
        legend: {
          position: 'right',
          labels: {
            padding: 20,
            boxWidth: 10,
            fontColor: this.fontColor,
            fontSize: 12
          }
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: context => {
              const index = context.index;
              return `${this.labels1[index].replace('$count', this.customerChartData1[index].toString())}`;
            }
          }
        },
        plugins: {
          doughnutlabel: {
            labels: [
              {
                text: chart => {
                  if(chart.data.datasets[0].data.reduce((a, b) => a + b)==0){
                    return this.accountDataObj.length
                  }
                  return chart.data.datasets[0].data.reduce((a, b) => a + b);
                },
                font: {
                  size: '26'
                }
              }
            ]
          }
        }
      },
      plugins: {
        beforeDraw(chart) {
          const legends = chart.legend.legendItems;
          legends.forEach((legend, i) => {
            legend.fillStyle = chart.config.data.datasets[0].backgroundColor[i];
            legend.strokeStyle = chart.config.data.datasets[0].backgroundColor[i];
            legend.lineWidth = 0;
            const value = chart.config.data.datasets[0].data[i];
            legend.text = legend.text.replace('$count', value);
          });
        }
      }
    });

    this.donutCustomerChart2 = new Chart(this.donutCustomer2.nativeElement, {
      type: 'doughnut',
      data: {
        labels: this.labels2,
        datasets: [
          {
            label: 'Donut Dataset',
            borderWidth: 0,
            backgroundColor: this.colors2,
            data: this.customerChartData2,
            borderColor: '#E557B3'
          }
        ]
      },
      options: {
        cutoutPercentage: 70,
        rotation: 120,
        maintainAspectRatio: false,
        legend: {
          position: 'right',
          labels: {
            padding: 20,
            boxWidth: 10,
            fontColor: this.fontColor,
            fontSize: 12
          }
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: context => {
              const index = context.index;
              return `${this.labels2[index].replace('$count', this.customerChartData2[index].toString())}`;
            }
          }
        },
        plugins: {
          doughnutlabel: {
            labels: [
              {
                text: chart => {
                  return chart.data.datasets[0].data.reduce((a, b) => a + b);
                },
                font: {
                  size: '26'
                }
              }
            ]
          }
        }
      },
      plugins: {
        beforeDraw(chart) {
          const legends = chart.legend.legendItems;
          legends.forEach((legend, i) => {
            legend.fillStyle = chart.config.data.datasets[0].backgroundColor[i];
            legend.strokeStyle = chart.config.data.datasets[0].backgroundColor[i];
            legend.lineWidth = 0;
            const value = chart.config.data.datasets[0].data[i];
            legend.text = legend.text.replace('$count', value);
          });
        }
      }
    });
  }

  public downloadDocument(globalNotificationId: string, fileExtension: string) {
    this.qnsbnservice.downloadPiosDocumentApi(globalNotificationId, fileExtension);
  }

  public downloadAttachment(fileName: string, notificationId: string) {
    this.qnsbnservice.downloadLocalAttachmentApi(fileName, notificationId);
  }

  public filterData() {
    this.filterOverlay.filterData$.subscribe(filterValue => {
      this.filterOverlayData = filterValue;
    });
    this.dialog.open(FilterOverlayDialogComponent, {
      data: this.filterOverlayData,
      autoFocus:false
    });
  }

  public isAllSelectedAccount($event) {
    const numSelected = this.accountSelection.selected.length;
    const numDisabled = this.accountDataSource.data.filter(row => row.disabled).length;
    const numRows = this.accountDataSource.data.length;
    return numSelected + numDisabled === numRows;
  }

  public masterToggleAccount($event) {
    this.isAllSelectedAccount($event) ? this.accountSelection.clear() : this.accountDataSource.data.forEach(row => (!row.disabled ? this.accountSelection.select(row) : ''));
  }

  public handleCheckedAccount(row: any) {
    if (!row.disabled) {
      this.accountSelection.toggle(row);
    }
  }

  public getAccountSelectedColumns() {
    this.accountSelectedColumns = this.accountSelection.selected.length > 0 ? this.accountSelection.selected : accountTableInit;
    sessionStorage.setItem('AccountSelectedColumns', JSON.stringify(this.accountSelectedColumns));
    this._cdr.detectChanges();
  }
  
  public isNoAttachmentsVisible(): boolean {
    const hasLocalAttachments = this.notificationData?.NotificationAttachments && 
    this.notificationData.NotificationAttachments.length > 0;

    const hasGlobalAttachments = this.notificationData?.DocumentEnabled === true &&
    this.notificationData?.NotificationDocuments &&
    this.notificationData.NotificationDocuments.length > 0 &&
    this.notificationData.NotificationDocuments[0]?.Title;

    return !hasLocalAttachments && !hasGlobalAttachments;
  }

  public addNoteForm(): void {
    const dialogRef = this.dialog.open(AddNoteComponent, {
      data: { tableData: this.notificationDataObj },
      disableClose: true
    });
    const existingNote = this.notificationDataObj?.notificationData?.NoteText;
     dialogRef.afterClosed().subscribe(newEntry => {
      if (newEntry !== true && newEntry.newNote !== existingNote) {
        this.notificationData.NoteDate = new Date();
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  public openDueDateRemindersDialog(): void {
    // To prevent multiple simultaneous API requests
    if (this.isFetchingReminderDetails) {
      return;
    }

    // To ensure notificationId is available
    if (!this.notificationId) {
      this.oneSnackBar.open('Notification details are unavailable.', OneSnackBarType.ERROR, '', { duration: 5000 });
      return;
    }

    this.isFetchingReminderDetails = true;

    // To fetch reminder details from the API
    this.qnsbnservice.viewReminderLocal(this.notificationId).subscribe(
      response => {
        if (response) {
          this.notificationData = response[0];
        }
        this.isFetchingReminderDetails = false;
        this.reminderDialogConfig();
      },
      (error: HttpErrorResponse) => {
        this.qnsbnservice.httpErrorHandler(error, 'Could not fetch reminder details.');
        this.isFetchingReminderDetails = false;
      }
    );
  }

  private reminderDialogConfig(): void {
    const dialogConfig = new MatDialogConfig();

    const reminderData = {
      notificationData: this.notificationData,
      notificationId: this.notificationId,
      feedbackEnabled: this.feedbackEnabled,
      accounts: this.contactDataObj
    };

    dialogConfig.data = reminderData;
    dialogConfig.width = '90vw';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.minWidth = '300px';
    dialogConfig.height = 'auto';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.hasBackdrop = true;
    dialogConfig.panelClass = 'due-date-reminder-dialog-panel';
    dialogConfig.position = {
      top: '5vh'
    };

    const dialogRef = this.dialog.open(DueDateReminderComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (typeof result.dueDateEnabled === 'boolean') {
          this.notificationData.DueDateEnabled = result.dueDateEnabled;
        }
        if (result.feedbackDueDate !== undefined) {
          this.notificationData.FeedbackDueDate = result.feedbackDueDate;
        }
        this._cdr.detectChanges();
      }
    });
  }
}